import React from 'react';

const DashboardPage: React.FC = () => {

  return (
    <div>
      <h1>Preparing</h1>
      <div>
        준비중입니다.
      </div>
    </div>
  );
};

export default DashboardPage;
